/**
 * Quote
 */
import clsx from 'clsx';
import React from 'react';
/** Main description for this component. */
var Quote = function (_a) {
    var children = _a.children, className = _a.className, author = _a.author, authorInfo = _a.authorInfo;
    return (React.createElement("blockquote", { className: clsx(className, 'relative text-center py-4 px-0 lg:px-4 w-full quote') },
        React.createElement("p", { className: clsx('text-quote-text-color', 'text-h3 lg:text-h2 lg:leading-9 mb-2 -mx-4 md:-mx-8 lg:-mx-24') }, "\"" + children + "\""),
        author && (React.createElement("cite", { className: "not-italic" },
            React.createElement("strong", { className: "block lg:inline-block" }, author),
            authorInfo && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "hidden lg:inline-block mx-1" }, "-"),
                authorInfo))))));
};
export default Quote;
